module.exports = __webpack_public_path__ + "img/band.48e5bb89.jpg";